import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { CommonService } from '@common/services/common.service';

@Component({
    selector: 'app-approvals-history-segment',
    templateUrl: './approvals-history-segment.component.html',
    styleUrls: ['./approvals-history-segment.component.scss'],
    providers: [CommonService]
})
export class ApprovalsHistorySegment implements OnInit {
    @Input() model: any;

    ngOnInit(): void {
        
    }      

    get approvedByFullName(): string {
        return this.model?.approvedBy?.fullName ?? '';
    }

    get rejectedByFullName(): string {
        return this.model?.rejectedBy?.fullName ?? '';
    }
}
